module.exports = __webpack_public_path__ + "static/media/golfer-8-a.3830735e.png";